<template>
  <div class="row" id="install-code" v-bind:class="{ scrollable: !embed }">
    <div class="col-md-11 mt-2 mx-auto" v-bind:class="{ 'col-md-12': embed }">
      <div class="row mr-3">
        <div class="col mb-3">
          <template v-if="embed">
            <h4 class="font-weight-bold">
              {{ t('Welcome to ' + $customdomain().name + '! 🎉') }}
            </h4>
            <h6 class="text-muted2 pt-2 mb-0">
              {{
                t(
                  'Now you are just one step away from using ' +
                    $customdomain().name +
                    ' to analyze your site'
                )
              }}
            </h6>
          </template>
          <template v-else>
            <h4 class="mt-4" v-translate>Installation Guide</h4>
          </template>
        </div>
        <div
          class="col-xs-3 col-sm-3 col-md-3 ml-auto text-right"
          v-if="!noExit && !embed"
        >
          <h4 class="mt-4 cursor-pointer">
            <font-awesome-icon
              class="fa-lg"
              @click="$modal.hide($parent.name)"
              icon="times"
            />
          </h4>
        </div>
      </div>
      <div class="row mt-3 mr-3">
        <div class="col-md-12 intro fs-16">
          <p>
            {{ $customdomain().name }} needs a little
            <span class="font-weight-bold text-primary">&lt;CODE&gt;</span>
            to do its thing. Follow the instructions below to install it on your
            site, and start using {{ $customdomain().name }}!
          </p>
          <p>My site is...</p>
        </div>
      </div>

      <div class="row mt-3 mr-3">
        <div class="col-md-12">
          <span
            class="tab no-drag"
            @click="selectedTab = 'html'"
            v-bind:class="{ selected: selectedTab === 'html' }"
            >HTML Website</span
          >
          <span
            class="tab no-drag"
            @click="selectedTab = 'wordpress'"
            v-bind:class="{ selected: selectedTab === 'wordpress' }"
            v-if="isHowuku"
            >Wordpress</span
          >
          <span
            class="tab no-drag"
            @click="selectedTab = 'opencart'"
            v-bind:class="{ selected: selectedTab === 'opencart' }"
            v-if="isHowuku"
            >Opencart</span
          >

          <span class="tab no-drag text-muted" v-if="isHowuku">
            <a
              href="https://howuku.freshdesk.com/support/solutions/folders/150000376970"
              target="_blank"
              class="text-muted a-link"
              ><font-awesome-icon
                icon="external-link-alt"
                class="mr-1 fa-sm"
              />view all other supported site</a
            >
          </span>
        </div>
      </div>

      <div class="row mt-3 mr-3">
        <div class="col-md-12" v-if="selectedTab === 'html'">
          <h6 v-translate class="mt-4 font-weight-bold">
            1. Copy Tracking Code Snippet
          </h6>
          <span class="font-weight-normal fs-16"
            >Copy and paste the code snippet into
            <span class="font-weight-bold text-primary">&lt;HEAD&gt;</span> tag
            on every page where you wish to track visitors and collect
            feedback.</span
          >
          <div class="mt-3">
            <span
              class="cursor-pointer btn btn-first m-2 px-2"
              id="btn-copy"
              style="position: absolute; right: 20px; padding: 5px"
              @click="copyToClipboard"
              >Copy to clipboard</span
            >
            <pre
              id="code-snippet"
              class="font-weight-bold baby-blue"
              v-if="$isHowuku && 1 === 2"
            >
&lt;!-- {{ $customdomain().name }} Tracking Code -->
&lt;script>
(function(h,o,w,u,k,u){
  u=['track','identify','converted'],h.o=h.howuku||{},
  u.map(function(n){return h.o[n]=h.o[n]||function(){(h.o[n].q=h.o[n].q||[]).push(arguments);};}),h.howuku=h.o,
  k=o.createElement("script"),k.type="text/javascript",k.async=true,k.src="https://{{ $trackingURL()}}/js/{{
                $session.get('company_id') === 1334 ? 'track' : 'howu'
              }}.js",k.setAttribute("key",w),
  o.getElementsByTagName("head")[0].appendChild(k);
})(window, document, "{{ secretCode }}");
&lt;/script></pre
            >

            <pre id="code-snippet" class="font-weight-bold baby-blue" v-else>
&lt;!-- {{ $customdomain().name }} Tracking Code -->
&lt;script>
(function(t,r,a,c,k){
  c=['track','identify','converted'],t.o=t._init||{},
  c.map(function(n){return t.o[n]=t.o[n]||function(){(t.o[n].q=t.o[n].q||[]).push(arguments);};}),t._init=t.o,
  k=r.createElement("script"),k.type="text/javascript",k.async=true,k.src="https://{{ $trackingURL()}}/js/track.js",k.setAttribute("key",a),
  r.getElementsByTagName("head")[0].appendChild(k);
})(window, document, "{{ secretCode }}");
&lt;/script></pre
            >
          </div>
          <h6 v-translate class="mt-4 font-weight-bold">
            2. Verify installation
          </h6>
          <span class="font-weight-normal fs-16">
            Enter your website URL where you have installed
            {{ $customdomain().name }} tracking code. This will open a popup
            window.
          </span>
          <br />
          <br />
          <input
            class="form-control d-inline w-25"
            placeholder="e.g. https://www.yourwebsite.com"
            type="text"
            v-model="websiteURL"
          />
          <button class="btn btn-muted" @click="verifyWebsite(secretCode)">
            Verify Installation
          </button>
          <br />
          <span class="text-muted2"
            >e.g. http://www.yourwebsite.com or http://localhost:8000</span
          >

          <br />
          <h6 v-translate class="mt-4 font-weight-bold">3. Done!</h6>
          <span class="font-weight-normal fs-16">
            It should be that easy, but if something's not working or you need
            more help:
            <br />
            <a
              class="btn btn-third btn-md mt-3"
              :href="
                'mailto:?subject=I%20Need%20Help%20Installing%20' +
                $customdomain().name +
                '%20Tracking%20Code&amp;body=Hi%2C%0A%0ACan%20you%20help%20me%20to%20install%20' +
                $customdomain().name +
                '%20analytic%20tracking%20code%20on%20my%20site%3F%20%0A%0A' +
                fullCode +
                '%0A%0AJust%20copy%20and%20paste%20the%20code%20above%20and%20place%20it%20right%20above%20the%20closing%20%3CHEAD%3E%20on%20my%20site.%0A%0AThanks!'
              "
              target="_blank"
              >Email code to your developer</a
            >
            <br />
            <br />
            <br />
            <br />
            <br />
          </span>
        </div>
        <div class="col-md-12" v-else>
          <h6 v-translate class="mt-4 font-weight-bold">
            1. Install {{ selectedTab | capitalize }} Plugin
          </h6>
          <p class="fs-18 font-weight-normal">
            <a
              :href="
                selectedTab === 'wordpress'
                  ? 'https://wordpress.org/plugins/howuku/'
                  : 'https://www.opencart.com/index.php?route=marketplace/extension/info&extension_id=39328&filter_category_id=8&filter_license=0&filter_download_id=59&sort=date_added'
              "
              target="_blank"
              >Click here</a
            >
            to go and install {{ selectedTab | capitalize }} plugin for
            {{ $customdomain().name }}.
          </p>

          <h6 v-translate class="mt-4 font-weight-bold">
            2. Copy Tracking Code Snipper
          </h6>
          <span class="font-weight-normal fs-16"
            >Here's your unique Code snippet. Click this code to copy it right
            to your clipboard.</span
          >
          <div>
            <span
              class="cursor-pointer btn btn-first m-2 px-2"
              id="btn-copy"
              style="position: absolute; right: 20px; padding: 5px"
              @click="copyToClipboard"
              >Copy to clipboard</span
            >
            <code>
            <pre
              id="code-snippet"
              class="font-weight-bold dialog-flex baby-blue"
              v-if="$isHowuku && 1 === 2"
            >
&lt;!-- {{ $customdomain().name }} Tracking Code -->
&lt;script>
(function(h,o,w,u,k,u){
  u=['track','identify','converted'],h.o=h.howuku||{},
  u.map(function(n){return h.o[n]=h.o[n]||function(){(h.o[n].q=h.o[n].q||[]).push(arguments);};}),h.howuku=h.o,
  k=o.createElement("script"),k.type="text/javascript",k.async=true,k.src="https://{{ $trackingURL()}}/js/{{
                $session.get('company_id') === 1334 ? 'track' : 'howu'
              }}.js",k.setAttribute("key",w),
  o.getElementsByTagName("head")[0].appendChild(k);
})(window, document, "{{ secretCode }}");
&lt;/script></pre
            >

            <pre id="code-snippet" class="font-weight-bold baby-blue" v-else>
&lt;!-- {{ $customdomain().name }} Tracking Code -->
&lt;script>
(function(t,r,a,c,k){
  c=['track','identify','converted'],t.o=t._init||{},
  c.map(function(n){return t.o[n]=t.o[n]||function(){(t.o[n].q=t.o[n].q||[]).push(arguments);};}),t._init=t.o,
  k=r.createElement("script"),k.type="text/javascript",k.async=true,k.src="https://{{ $trackingURL() }}/js/track.js",k.setAttribute("key",a),
  r.getElementsByTagName("head")[0].appendChild(k);
})(window, document, "{{ secretCode }}");
&lt;/script></pre
            ></code>
          </div>
          <h6 v-translate class="mt-4 font-weight-bold">
            3. Paste it into your {{ selectedTab | capitalize }} plugin
          </h6>
          <span class="font-weight-normal fs-16"
            >Paste the code into your {{ $customdomain().name }} plugin and save
            it.</span
          >
          <br />
          <h6 v-translate class="mt-4 font-weight-bold">
            4. Verify installation
          </h6>
          <span class="font-weight-normal fs-16">
            Enter your website URL where you have installed
            {{ $customdomain().name }} tracking code. This will open a popup
            window.
          </span>
          <br />
          <br />
          <input
            class="form-control d-inline w-25"
            placeholder="e.g. https://www.yourwebsite.com"
            type="text"
            v-model="websiteURL"
          />
          <button class="btn btn-muted" @click="verifyWebsite(secretCode)">
            Verify Installation
          </button>
          <br />
          <span class="text-muted2"
            >e.g. http://www.yourwebsite.com or http://localhost:8000</span
          >

          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['secretCode', 'noExit', 'embed', 'selectedWidgetId'],
  data: function () {
    return {
      isHowuku:
        window.location.href.includes('howuku.com') ||
        window.location.href.includes('localhost:'),
      fullCode: '',
      selectedTab: 'html',
      websiteURL: '',
      pageview: 0
    }
  },
  created() {
    this.$http
      .post(process.env.API_ENDPOINT + '/getWidgets', {
        widget_id: this.selectedWidgetId || this.$session.get('widget_id')
      })
      .then((response) => {
        let current = response.data[0]
        this.websiteURL = current.widget_allowed_website
        this.pageview = current.pageview_total
      })
  },
  mounted() {
    this.fullCode = document.getElementById('code-snippet').innerHTML
    this.fullCode = this.fullCode.replace(/&lt;/g, '<')
    this.fullCode = this.fullCode.replace(/&gt;/g, '>')
    this.fullCode = this.fullCode.replace(/ /g, '')
    this.fullCode = this.fullCode.replace(/var/g, 'var ')
    this.fullCode = this.fullCode.replace(
      /HowukuTrackingCode/g,
      ' Howuku Tracking Code '
    )
  },
  methods: {
    verifyWebsite(secretCode) {
      this.$http
        .post(process.env.API_ENDPOINT + '/saveWidget', {
          widget_id: this.$session.get('widget_id'),
          widget_allowed_website: this.websiteURL
        })
        .then((response) => {
          if (!this.websiteURL.startsWith('http')) {
            this.websiteURL = 'https://' + this.websiteURL
          }
          let newWindow = open(
            this.websiteURL + '?verify=' + secretCode,
            'example',
            'width=500,height=500'
          )
        })
    },
    copyToClipboard() {
      document.getElementById('btn-copy').textContent = 'Copied!'
      setTimeout(() => {
        document.getElementById('btn-copy').textContent = 'Copy to clipboard'
      }, 5000)
      let textToCopy = document.getElementById('code-snippet').innerHTML
      textToCopy = textToCopy.replace(/&lt;/g, '<')
      textToCopy = textToCopy.replace(/&gt;/g, '>')
      // 1) Add the text to the DOM (usually achieved with a hidden input field)
      const input = document.createElement('textarea')
      document.getElementById('install-code').appendChild(input)
      input.value = textToCopy

      // 2) Select the text
      input.focus()
      input.select()

      // 3) Copy text to clipboard
      const isSuccessful = document.execCommand('copy')
      input.parentElement.removeChild(input)

      // 4) Catch errors
      if (!isSuccessful) {
        console.error('Failed to copy text.')
      }
    }
  }
}
</script>
<style scoped>
pre.baby-blue {
  background-color: #e2f3ff;
  border: 1px solid #c7e4ff;
  color: rgb(253, 39, 0) !important;
  padding: 30px;
}

.selected {
  font-weight: bold;
  /* border-bottom: 3px solid #ff6550; */
  background-color: #efefef;
  border-radius: 8px;
}

.tab {
  font-size: 14px;
  margin-right: 20px;
  padding: 10px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/GetCode.vue